<template>
    <div class="editor-row customize-editor-minimize">
        <div class="editor-row-title">Json Path</div>
        <TiptapEditor
            placeholder="Json Path: e.g. $.store.book[0].title"
            :show-attributes="true"
            v-model="clone.jsonpath.value"
            :show-emoji="false"
            automation-mode
        />
    </div>
</template>

<script>
import log2 from "../../../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";

const log = log2("StringFormatterJsonPath");
export default {
    name: "StringFormatterJsonPath",
    components: { TiptapEditor },
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            mode: "string.capitalize",
            value: "",
            regex: {
                pattern: "",
                flags: "",
                matchAll: false,
            },
            find: {
                skip: "0",
                pattern: "",
            },
            split: {
                delimiter: " ",
                take: "0",
            },
            truncate: {
                maxLength: "0",
                skipChars: "0",
                appendEllipsis: false,
            },
            default: {
                value: "",
            },
        };
        return {
            clone,
        };
    },
    methods: {},
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
        value(newValue) {
            if (_.isEqual(newValue, this.clone)) return;
            this.clone = _.cloneDeep(newValue);
        },
    },
};
</script>

<style lang="scss" scoped>
.editor-row {
    width: 100%;

    &.customize-editor-minimize {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    small.description {
        font-size: 10px;
        color: var(--color-text-weak-default);
    }

    .editor-row-title {
        font-weight: bold;
        font-size: 16px;
    }
}
</style>
